export default __webpack_public_path__ + "static/media/hashtag.4c25d9db.svg";